export namespace QuizType {
  export enum Values {
    PRE = 'PRE',
    POST = 'POST',
    DIAG_START = 'DIAG_START',
    DIAG_END = 'DIAG_END'
  }

  export function label(quiz: Values) {
    switch (quiz) {
      case Values.PRE:
        return 'Pré-quiz'
      case Values.POST:
        return 'Post-quiz'
      case Values.DIAG_START:
        return 'Diagnostic D1'
      case Values.DIAG_END:
        return 'Diagnostic D2'
    }
  }
}
